export const routes = {
  home: "/",
  login: "/login",
  signup: "/sign-up",
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
};
